const RESERVED_SLUGS = [
  "admin",
  "doctor",
  "patient",
  "fisioterapeuta",
  "super-admin",
  "login",
  "cadastro",
  "recuperar-senha",
  "redefinir-senha",
  "selecionar-cliente",
  "sobre",
  "servicos",
  "noticias",
  "contato",
  "agendar",
  "cursos",
  "eventos",
  "teste",
  "acesso-negado",
] as const;

export const RESERVED_TENANT_SLUGS = new Set<string>(RESERVED_SLUGS);
export const TENANT_SLUG_REGEX = /^[a-z0-9]+(?:-[a-z0-9]+)*$/;

export const normalizeTenantSlug = (value: string): string => {
  return value
    .normalize("NFD")
    .replace(/[\u0300-\u036f]/g, "")
    .toLowerCase()
    .replace(/[^a-z0-9]+/g, "-")
    .replace(/^-+|-+$/g, "");
};

export const isReservedTenantSlug = (value: string): boolean => {
  return RESERVED_TENANT_SLUGS.has(value.trim().toLowerCase());
};

export const isValidTenantSlug = (value: string): boolean => {
  return TENANT_SLUG_REGEX.test(value);
};

export const extractTenantSlugFromPathname = (pathname: string): string | null => {
  if (!pathname) return null;

  const [firstSegment] = pathname.replace(/^\/+/, "").split("/");
  if (!firstSegment) return null;

  const normalizedSegment = normalizeTenantSlug(firstSegment);
  if (!normalizedSegment || isReservedTenantSlug(normalizedSegment)) {
    return null;
  }

  return normalizedSegment;
};

export const buildTenantPath = (path: string, tenantSlug?: string | null): string => {
  const normalizedPath = path.startsWith("/") ? path : `/${path}`;

  if (!tenantSlug) {
    return normalizedPath;
  }

  const tenantPrefix = `/${tenantSlug}`;
  if (normalizedPath === tenantPrefix || normalizedPath.startsWith(`${tenantPrefix}/`)) {
    return normalizedPath;
  }

  if (normalizedPath === "/") {
    return tenantPrefix;
  }

  return `${tenantPrefix}${normalizedPath}`;
};
